<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global active" id="Loader" *ngIf="isLoading">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<div class="login-wrapper" *ngIf="!isLoading && showLoginForm">
  <div class="login-card">
    <div class="login-card-left">
      <div class="login-logo-container">
        <img src="assets/Global/Icon_SINCO.png" alt="Grupo SINCO" class="login-logo-img" />
      </div>
      <h1>Librerías</h1>
      <p>Controlled Document Management System</p>
      <div class="login-features">
        <div class="feature-item">
          <i class="fa fa-folder-open"></i>
          <span>Gestión de documentos controlados</span>
        </div>
        <div class="feature-item">
          <i class="fa fa-check-circle"></i>
          <span>Flujos de aprobación automatizados</span>
        </div>
        <div class="feature-item">
          <i class="fa fa-history"></i>
          <span>Control de versiones y auditoría</span>
        </div>
      </div>
    </div>

    <div class="login-card-right">
      <div class="login-form-header">
        <h2>Bienvenido</h2>
        <p>Ingresa tu usuario para continuar</p>
      </div>

      <form (ngSubmit)="onLogin()" class="login-form">
        <div class="input-group">
          <i class="fa fa-user input-icon-fa"></i>
          <input
            type="text"
            id="loginName"
            [(ngModel)]="loginName"
            name="loginName"
            placeholder="LoginName"
            required
            autocomplete="username"
            [class.input-error]="loginError"
          />
        </div>
        
        <div class="input-group">
          <i class="fa fa-key input-icon-fa"></i>
          <input
            type="password"
            id="Password"
            [(ngModel)]="Password"
            name="Password"
            placeholder="Password"
            required
            [class.input-error]="loginError"
          />
        </div>

        <div class="error-message" *ngIf="loginError">
          <i class="fa fa-exclamation-circle"></i>
          <span>{{ loginError }}</span>
        </div>

        <button type="submit" class="btn-login">
          <span>Iniciar Sesión</span>
          <i class="fa fa-arrow-right"></i>
        </button>
      </form>

      <div class="forgot-password">
        <a href="#" (click)="onForgotPassword($event)">
          <i class="fa fa-key"></i>
          ¿Olvidaste tu contraseña?
        </a>
      </div>

      <div class="login-footer">
        <span>Entorno de desarrollo</span>
      </div>
    </div>
    
  </div>
</div>
